import {
  Box,
  Checkbox,
  Flex,
  Image,
  Spacer,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import FormInput from "../../../components/input/";
import { title } from "../../../utils/constants";
import { color } from "../../../utils/theme";
import { Divider } from "@chakra-ui/react";
import { useFormik } from "formik";
import FormButton from "../../../components/button/";
import { loginFormik } from "../../../utils/formik/login";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { setUser } from "../../../redux/action/userAction";
import { loginUser } from "../login/loginService";
import AppAlertOne from "../../../components/alert/type1";
import { Link } from "@chakra-ui/react";
import { User } from "../../../utils/types/user";

const Login = () => {
  const [submitting, setSubmitting] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const formik = useFormik({
    ...loginFormik,
    onSubmit: async () => {
      setSubmitting(true);
      const response = await loginUser(formik.values);
      if (response.success) {
        const user = response.data;
        console.log("user: ", user);

        localStorage.setItem("token", user.token);
        setShowError(false);
        dispatch(setUser(user as User) as any);
        navigate("/");
      } else {
        const error = response.data;
        displayErrorMessages(error.code);

        console.log("login error");

        setSubmitting(false);
      }
    },
  });
  const displayErrorMessages = (error: any) => {
    setShowError(true);
    if (error === "INCORRECT_PASSWORD") {
      setErrorMessage("Invalid username or password!");
    } else if (error === "USER_NOT_FOUND") {
      setErrorMessage("User not found!");
    } else {
      setErrorMessage("An error occurred, please try again later");
    }

    setTimeout(() => {
      setShowError(false);
      setErrorMessage("");
    }, 3000);
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Flex
      w={"100%"}
      height={"100%"}
      style={{ height: "100vh", width: "100vw" }}
      bg={"#f1f1f1"}
      opacity={1}
    >
      <Box
        bg={color.secondary}
        display={"flex"}
        alignContent={"center"}
        justifyContent={"center"}
        flexDirection={"column"}
        w={"50%"}
        p={5}
        h={"100%"}
        textAlign={"left"}
        shadow={"sm"}
      >
        <Text
          color={color.primary}
          ml={20}
          fontSize={[18, 22, 24, 24, 24, 30]}
          fontWeight={"bold"}
          mt={20}
          variant={"Header"}
        >
          Welcome to {title}
        </Text>
        {/* <Text
          color={color.text}
          ml={20}
          fontSize={[18, 18, 18, 18, 16, 22]}
          mr={20}
          mt={5}
        >
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Natus
          facilis minima laboriosam officiis aut expedita,
        </Text> */}
        <Image
          style={{ alignSelf: "center" }}
          mx={"auto"}
          src={require("../../../assets/welocme.png")}
          w={["75%", "75%", "75%", "75%", "75%", "90%"]}
          h={["35%", "50%"]}
        />
        <Box mt={2}>
          <Divider
            bgColor={color.primary}
            color={color.primary}
            style={{ backgroundColor: color.primary }}
          />
          <Text
            textAlign={"center"}
            fontWeight={"semibold"}
            fontSize={11}
            mt={5}
            color={color.primary}
          >
            Version 1.0.1 @ 2024
          </Text>
        </Box>
      </Box>

      <Box
        bg={color.secondary}
        w={"50%"}
        h={"100%"}
        display={"flex"}
        justifyContent={"center"}
        alignContent={"center"}
        alignItems={"center"}
        borderBottomRightRadius={30}
        shadow={"sm"}
      >
        <Stack
          rounded={"md"}
          boxShadow={"sm"}
          borderWidth={0.5}
          borderColor={color.teritary}
          padding={10}
          w={["100%", "75%", "50%", "75%", "75%", "50%"]}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"flex-start"}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignContent={"center"}
            alignItems={"center"}
            height={"100%"}
          >
            <Image
              width="10%"
              height="auto"
              src={require("../../../assets/logo.png")}
            />
            <Text color={color.text} fontSize={14} variant={"Header"}>
              Sign in to your account
            </Text>
          </Box>
          <Divider />
          {showError && (
            <Box h={10}>
              <AppAlertOne
                body={errorMessage}
                status="error"
                onClose={() => {
                  setShowError(false);
                  setErrorMessage("");
                }}
              />
            </Box>
          )}
          <Box mt={4}>
            <FormInput
              name="username"
              isRequired={true}
              value={formik.values.username}
              label="User name"
              type="text"
              id="username"
              errorMessage={formik.errors.username as string}
              onChange={(event) => {
                formik.setFieldValue("username", event.target.value);
              }}
            />
            <Spacer sx={{ my: 5 }} />
            <FormInput
              id="password"
              isRequired={true}
              value={formik.values.password}
              name="password"
              label="Password"
              type={showPassword ? "text" : "password"}
              errorMessage={formik.errors.password as string}
              onChange={(event) => {
                formik.setFieldValue("password", event.target.value);
              }}
            />
            <Checkbox
              size="md"
              mt={2}
              fontWeight={"normal"}
              colorScheme="blue"
              color={color.text}
              w={"100%"}
              onChange={(e) => setShowPassword(e.target.checked)}
            >
              Show Password
            </Checkbox>
            <Spacer sx={{ my: 5 }} />

            <FormButton
              colorScheme={"blue"}
              onClick={formik.handleSubmit}
              isLoading={submitting ? true : false}
            >
              Login
            </FormButton>
            <Divider />
            <Text fontSize={15} textAlign={"center"} mt={2}>
              Don't have an account?{" "}
              <Link color="blue.500" href="/signup" fontWeight={"semibold"}>
                Sign Up
              </Link>
            </Text>
          </Box>
        </Stack>
      </Box>
    </Flex>
  );
};

export default Login;
